import React from 'react';

import { InfoIcon } from '@/shared/assets/icons/info-icon';
import { TSelectFilterOption } from '@/shared/components/ui/option-select/option-select.types';
import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';

type TIdeOption = {
  label: string;
  value: string;
  additionalInformation?: string | null;
};

// value is an IDE's identity, but the same one surfaces under multiple vendors,
// sometimes with an inconsistently-cased label. Collapse by value + detail
// (keeping entries whose detail genuinely differs), enrich each with an info-icon
// tooltip, then sort by label.
export const mapIdeOptionsWithInfo = (
  options: TIdeOption[],
): TSelectFilterOption[] => {
  const uniqueOptions = [
    ...new Map(
      options.map((option) => [
        JSON.stringify([option.value, option.additionalInformation ?? '']),
        option,
      ]),
    ).values(),
  ];

  return uniqueOptions
    .map(({ label, value, additionalInformation }) => {
      if (!additionalInformation) {
        return { label, value };
      }

      return {
        label,
        value,
        additionalInfo: (
          <Tooltip title={additionalInformation} placement="right">
            <InfoIcon color="textSecondary" size="1rem" />
          </Tooltip>
        ),
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
};
